module.exports = __webpack_public_path__ + "img/landing-background.7108d516.png";